/**
 * Modal Component
 * Overlay component for dialogs and modals
 */

import React from "react";

export interface ModalProps {
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
  size?: "small" | "medium" | "large" | "extraLarge" | "full";
  closeOnOverlayClick?: boolean;
  closeOnEscape?: boolean;
  title?: string;
  className?: string;
}

export function Modal({
  children,
  isOpen,
  onClose,
  size = "medium",
  closeOnOverlayClick = true,
  closeOnEscape = true,
  title,
  className,
  ...props
}: ModalProps) {
  // Implementation will be added later
  if (!isOpen) return null;

  return (
    <div className={className} {...props}>
      {title && <h2>{title}</h2>}
      {children}
    </div>
  );
}
